import { render } from "./Population.vue?vue&type=template&id=255e3dda"
import script from "./Population.vue?vue&type=script&lang=js"
export * from "./Population.vue?vue&type=script&lang=js"

import "./Population.vue?vue&type=style&index=0&id=255e3dda&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__